import { render, staticRenderFns } from "./Cosechadoras.vue?vue&type=template&id=b801ca9c&"
import script from "./Cosechadoras.vue?vue&type=script&lang=ts&"
export * from "./Cosechadoras.vue?vue&type=script&lang=ts&"
import style0 from "./Cosechadoras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports